import { TvpilJournalCategory } from './categories';
import {
  TvpilJournalAppServiceEvent,
  TvpilJournalAppStoreEvent,
  TvpilJournalConfigurationEvent,
  TvpilJournalErrorEvent,
  TvpilJournalRailEvent,
  TvpilJournalUserStoreEvent,
} from './events';
import { TvpilJournalMeta } from './types';

let tvpilMeta: TvpilJournalMeta | undefined;

export function setJournalMeta(meta: TvpilJournalMeta) {
  tvpilMeta = meta;
}

function createEventFactory<TEvent>(category: TvpilJournalCategory) {
  return function createEvent<Key extends keyof TEvent>(
    name: Key,
    payload?: Omit<TEvent[Key], keyof TvpilJournalMeta>,
  ) {
    return {
      name,
      category,
      payload: {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...tvpilMeta!,
        ...(payload ?? {}),
      },
    };
  };
}

export const createAppServiceEvent = createEventFactory<TvpilJournalAppServiceEvent>('AppService');
export const createAppStoreEvent = createEventFactory<TvpilJournalAppStoreEvent>('AppStore');
export const createConfigurationEvent = createEventFactory<TvpilJournalConfigurationEvent>('Configuration');
export const createErrorEvent = createEventFactory<TvpilJournalErrorEvent>('Error');
export const createRailEvent = createEventFactory<TvpilJournalRailEvent>('Rail');
export const createUserStoreEvent = createEventFactory<TvpilJournalUserStoreEvent>('UserStore');
